import { NavLink, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import FastSendLogo from "./FastSendLogo";

const USER_TABS = [
  { to: "/dashboard",    icon: "🏠", label: "Dashboard"       },
  { to: "/order",        icon: "📦", label: "Send Package"    },
  { to: "/orders",       icon: "📋", label: "My Orders"       },
  { to: "/wallet",       icon: "💰", label: "Wallet"          },
  { to: "/subscription", icon: "⭐", label: "Subscription"    },
  { to: "/business",     icon: "🏢", label: "Business"        },
  { to: "/profile",      icon: "👤", label: "Profile"         },
  { to: "/guide",        icon: "📖", label: "Guide"           },
];

export default function BottomNav() {
  const { logout, account } = useAuth();

  // Corporate accounts book exclusively through their own dashboard (see
  // PlaceOrder.js's redirect) — no separate "Send Package" entry for them.
  const isApprovedCorporate = account?.corporateApprovalStatus === "approved";
  const tabs = isApprovedCorporate ? USER_TABS.filter(t => t.to !== "/order") : USER_TABS;

  return (
    <>
      {/* ── Mobile-only floating logout — sibling of <nav>, not a child (see
          AdminNav.js for why: .app-nav's backdrop-filter creates a new
          containing block for fixed-position descendants). ── */}
      <button type="button" className="app-nav-mobile-logout" onClick={logout} aria-label="Log out">
        🚪
      </button>
      <nav className="app-nav">
      {/* ── Brand (sidebar only) ── */}
      <div className="app-nav-brand">
        <Link to="/dashboard" className="app-nav-logo-link" style={{ display: "inline-block", padding: "4px 0" }}>
          <FastSendLogo variant="horizontal" size="small" />
        </Link>
        {account && (
          <div className="app-nav-user">
            <div className="app-nav-avatar">
              {account.name?.charAt(0)?.toUpperCase() || "U"}
            </div>
            <div className="app-nav-user-info">
              <span className="app-nav-user-name">{account.name}</span>
              <span className="app-nav-user-role">Customer</span>
            </div>
          </div>
        )}
      </div>

      {/* ── Nav Items ── */}
      <div className="app-nav-items">
        {tabs.map(({ to, icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `app-nav-item${isActive ? " active" : ""}`
            }
          >
            <span className="app-nav-item-icon">{icon}</span>
            <span className="app-nav-item-label">{label}</span>
          </NavLink>
        ))}
      </div>

      {/* ── Footer / Logout (sidebar only) ── */}
      <div className="app-nav-footer">
        <button className="app-nav-item app-nav-logout" onClick={logout}>
          <span className="app-nav-item-icon">🚪</span>
          <span className="app-nav-item-label">Log out</span>
        </button>
      </div>
      </nav>
    </>
  );
}
